import { ArticleCurdVm } from "../../models/view/article-curd.vm";

export class ArticleCurdEvents {
    constructor(public article: ArticleCurdVm) {
    }
}
